import React from "react";
import { FormGroup, Label, Row, Col } from "reactstrap";

interface TimeInputProps {
  label: string;
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
}

const DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const TimeInput: React.FC<TimeInputProps> = ({ label, value, onChange }) => {
  const handleChange = (day: string, time: string) => {
    onChange({
      ...value,
      [day]: time,
    });
  };

  return (
    <FormGroup>
      <Label className="fw-bold">{label}</Label>
      {DAYS.map((day) => (
        <Row key={day} className="mb-2">
          <Col md={3}>
            <Label className="mt-2">{day}</Label>
          </Col>
          <Col md={9}>
            <input
              type="text"
              className="form-control"
              value={value[day] || ""}
              onChange={(e) => handleChange(day, e.target.value)}
              placeholder="e.g., 9:00 AM - 5:00 PM or Closed"
            />
          </Col>
        </Row>
      ))}
    </FormGroup>
  );
};

export default TimeInput;
